import { render, staticRenderFns } from "./ProductInfoCard.vue?vue&type=template&id=c072d08e"
import script from "./ProductInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoCard.vue?vue&type=style&index=0&id=c072d08e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports